module.exports = __webpack_public_path__ + "img/md-resize.dc9eb61d.svg";